import { Tooltip } from '@chr/eds-react';
import './icons.scss';

export const HazMatSvgIcon = () =>
  <Tooltip title="Hazardous Materials" data-testid="hazmat-icon">
    <span role="img" aria-label='Hazardous Materials Icon' className='icon hazmat' />
  </Tooltip>

export const TempSvgIcon = () =>
  <Tooltip title="Temperature Control" data-testid="temp-control-icon">
    <span role="img" aria-label='Temperature Control Icon' className='icon temp-control' />
  </Tooltip>

